import styled from 'styled-components';

export const LocationWrapper = styled.div`
  margin-top: 16px;
  & > div:last-child {
    margin-top: 14px;
  }
`;

export const DeleteContainer = styled.div`
  display: flex;
  margin-bottom: 16px;
  & > div:first-child {
    margin-right: 16px;
  }

  & > div:last-child {
    cursor: pointer;
  }
`;

export const FormItemWrapper = styled.div`
  display: flex;
  gap: 48px
`;
